import { useInfoCenterPublic } from '@content-api/provider';
import { TermsAndConditionsType } from '@content-api/api';
import { useQuery } from '@tanstack/react-query';

export const useGetTermsAndConditions = () => {
  const { getLatestTermsAndConditions } = useInfoCenterPublic();

  const { data: termsAndConditions } = useQuery({
    queryKey: ['content-api', 'terms-and-conditions'],
    queryFn: () => getLatestTermsAndConditions(),
  });

  const termsOfServicesBusiness = termsAndConditions?.find(
    (term) => term.type === TermsAndConditionsType.BUSINESS_SERVICE_TERMS,
  );

  const dataProcessingAgreement = termsAndConditions?.find(
    (term) => term.type === TermsAndConditionsType.DATA_PROCESSING_TERMS,
  );

  const businessWalletTerms = termsAndConditions?.find(
    (term) => term.type === TermsAndConditionsType.BUSINESS_WALLET_TERMS,
  );

  return {
    termsOfServicesBusiness,
    dataProcessingAgreement,
    businessWalletTerms,
  };
};
